import { useAuth } from '../context/AuthContext';

export function usePermissions() {
  const { hasPermission, hasModuleAccess, permissionsLoaded, isSuperAdmin, user } = useAuth();

  return {
    hasPermission,
    hasModuleAccess,
    permissionsLoaded,
    isSuperAdmin,
    user,
    canView: (module) => hasPermission(module, 'view'),
    canCreate: (module) => hasPermission(module, 'create'),
    canEdit: (module) => hasPermission(module, 'edit'),
    canApprove: (module) => hasPermission(module, 'approve'),
    canDeactivate: (module) => hasPermission(module, 'deactivate'),
    canExport: (module) => hasPermission(module, 'export'),
    userRole: user?.role?.name,
  };
}

export default usePermissions;
